export enum ProjectStatusFilter {
  ALL_ACTIVE_PROJECTS = 'ALL_ACTIVE_PROJECTS',
  SIZING_COMPLETED = 'SIZING_COMPLETED',
  VALIDATED = 'VALIDATED',
  ARCHIVED = 'ARCHIVED',
}
